import { Logo } from '../components/Logo'
import { Aco } from '../components/Aco';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';
import styled from 'styled-components';

const data = [
  {ja: 'リナロール', en: 'Linalool', value: '1.02%', description: 'リナロールは、花やスパイスのような香りを持つ、植物由来の芳香性アルコールです。広く香料や化粧品業界で利用されています。リナロールはまた、抗炎症、抗菌、鎮痛作用があり、アロマセラピーで利用されることがあります。'},
  {ja: 'フェネチル', en: 'Phenethyl', value: '59.33%', description: 'フェネチルアルコールは、バラ、ジャスミン、ユリなどの花にも含まれる、芳香性アルコールです。香料や化粧品において、花の香りを補完する目的で使用されます。また、抗菌性があり、製品の防腐効果にも役立ちます。'},
  {ja: 'シトロネロール', en: 'Citronellol', value: '21.46%', description: 'シトロネロールは、シトラス系の香りを持つ芳香性アルコールで、ローズやゼラニウムなどの花の香りを持ちます。香料や化粧品に広く使用されています。'},
  {ja: 'ゲラニオール', en: 'Geraniol', value: '9.85%', description: 'ゲラニオールは、バラやゼラニウムに見られる、花の香りを持つ芳香性アルコールです。香料や化粧品において、花の香りを補完する目的で使用されます。'},
  {ja: 'オイゲノール', en: 'Eugenol', value: '1.27%', description: 'オイゲノール（ユージノールとも言う）は、クローブ、シナモン、ナツメグなどのスパイスに含まれる、芳香性化合物です。スパイシーな香りとして知られており、香料や化粧品に使用されます。'},
]

const DetailedTableRow = styled.div`
  border-bottom: 1px solid #E8DDD5;
  padding: 20px 0;
  
  &:last-child {
    border-bottom: none;
  }
`;

const ComponentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const ComponentName = styled.h5`
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 16px;
  color: #3E2723;
  font-weight: 500;
  margin: 0;
`;

const ComponentValue = styled.span`
  font-family: 'Roboto Mono', monospace;
  font-size: 18px;
  color: #4A5D23;
  font-weight: 500;
`;

const ComponentDescription = styled.p`
  color: #6D4C41;
  line-height: 1.8;
  margin: 0;
  font-size: 14px;
`;

export const RoseAbsolute = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>
    
    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />
          
          <ProductTitle>ローズアブソリュート</ProductTitle>
          <ProductSubtitle>Rose centifolia</ProductSubtitle>
          
          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2025-09-01T09:00:00.000Z').toLocaleDateString()}</Paragraph>
          
          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>モロッコ</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>花</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>アブソリュート (有機溶剤抽出法)</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>rose centifolia (ロサ・ケンティフォリア)</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>バラ科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>-</TableData>
              </TableRow>
            </tbody>
          </InfoTable>
          
          <SectionTitle>分析証明書</SectionTitle>
          
          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: ローズアブソリュート</li>
            <li>学名: rose centifolia (ロサ・ケンティフォリア)</li>
          </List>
          
          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: -</li>
            <li>香り: -</li>
            <li>比重: -</li>
            <li>屈折率: -</li>
          </List>
          
          <SubSectionTitle>ガスクロマトグラフ分析結果</SubSectionTitle>
          <div style={{ background: '#FAFAF8', borderRadius: '8px', padding: '20px', marginTop: '20px' }}>
            {data.map((item, index) => (
              <DetailedTableRow key={index}>
                <ComponentHeader>
                  <ComponentName>{item.ja}</ComponentName>
                  <ComponentValue>{item.value}</ComponentValue>
                </ComponentHeader>
                <ComponentDescription>{item.description}</ComponentDescription>
              </DetailedTableRow>
            ))}
          </div>
        </MainContent>
        
        <SideContent>
          <AcoContainer>
            <Aco />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);




